/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import UnarchiveLocationForm from './UnarchiveLocationForm/UnarchiveLocationForm';
import UnarchiveLocationSuccess from './UnarchiveLocationSuccess/UnarchiveLocationSuccess';
import UnarchiveLocationError from './UnarchiveLocationError/UnarchiveLocationError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class UnarchiveLocation extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, accountStore, location }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'unarchiveReason',
        label: t('general:locations.reasons.why_unarchive'),
        fields: [
          {
            name: 'reason',
            label: t('general:reason'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        location.hierarchy || accountStore.loadLocationDetails(location.id);
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().unarchiveReason;

        actionDrawerStore.unarchiveLocation(location.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'unarchiveLocation',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location }: TypeProps = this.props;

    const title: string = t('general:actions.unarchive_location');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <UnarchiveLocationError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <UnarchiveLocationSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <UnarchiveLocationForm location={location} form={this.createForm()} />
      </div>
    );
  }
}
